export class CompraSituacaoRequest {
  idsCompra: number[] = [];
}
